export class OrderShipmentsInRouteDto {
	public routeId: number;
	public shipments: Array<OrderShipmentInRouteDto>;

	static build(routeId: number, shipments: Array<OrderShipmentInRouteDto>): OrderShipmentsInRouteDto{
		let result = new OrderShipmentsInRouteDto();
		result.routeId = routeId;
		result.shipments = shipments;
		return result;
	}
}

export class OrderShipmentInRouteDto {
	public shipmentId: number;
	public orderInRoute: number;

	static build(shipmentId: number, orderInRoute: number): OrderShipmentInRouteDto{
		let result = new OrderShipmentInRouteDto();
		result.shipmentId = shipmentId;
		result.orderInRoute = orderInRoute;
		return result;
	}
}